module.exports = __webpack_public_path__ + "static/media/whiteVeins.f6f09723.svg";